export function hideRemoveTidio(user: any) {
    const tidioIFrame = document.getElementById('tidio-chat-code');
    const tidioDiv = document.getElementById('tidio-chat');
    const tidioScript = document.getElementById('tidio_script');

    if (!user ) {
        if (!tidioDiv || !tidioIFrame || !tidioScript) return;
        document.body.removeChild(tidioDiv);
        document.body.removeChild(tidioIFrame);
        document.body.removeChild(tidioScript);
        return;
    }

    if (user?.roles[0] !== 'ROLE_MANAGER'){
        if (!tidioDiv || !tidioIFrame || !tidioScript) return;
        tidioDiv.style.display = 'none';
        tidioIFrame.style.display = 'none';
        return;
    }
}
